import 'utils/googleTranslateFix';

try {
	// eslint-disable-next-line no-undef
	__webpack_public_path__ = window.__BASE_URL__;
} catch (e) {}

import { h, render } from 'preact';
import { getData } from 'utils/dynamicData';

import UniversalHubApp from 'base/universalHub/universalHubApp';

// loads + cache essential data ASAP
(async () => {
	getData('navigation');
})();

let elem = document.getElementById('app');
if (!elem) {
	elem = document.createElement('div');
	elem.id = 'app';
	document.body.appendChild(elem);
}
render(<UniversalHubApp initialStore={window.__INITIAL_STATE__} />, elem, elem.firstChild);
